
import Vue from "vue"
import Locale from "@/components/Locale.vue"
import Theme from "@/components/Theme.vue"
import Logout from "@/components/Logout.vue"
import NavigationDrawerSwitch from "@/components/NavigationDrawerSwitch.vue"

export default Vue.extend({
  components: {
    Locale,
    Theme,
    Logout,
    NavigationDrawerSwitch
  },
})
